/* unplugin-vue-components disabled */import { render } from "./designated-driving-passenger-form.vue?vue&type=template&id=cc399492"
import script from "./designated-driving-passenger-form.vue?vue&type=script&lang=js"
export * from "./designated-driving-passenger-form.vue?vue&type=script&lang=js"

import "./designated-driving-passenger-form.vue?vue&type=style&index=0&id=cc399492&lang=less"

import exportComponent from "E:\\ProjectsWorkspaces\\WebStormProjects\\OCHS-Product-Disda-Online-Car-Hailing-H5\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_7401bc125e2957ce4091f6809056b31d\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__